// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "cc.dropp",
    name: "Dropp",
    homepage: "https://dropp.cc/",
    image_id: "526fb7ea-d0da-482a-ac84-7e38afea1700",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/dropp-cc/id1544894404",
        android: "https://play.google.com/store/apps/details?id=cc.dropp.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/dropp-extension/hgfpnmhnmmneldokmpncjmeijkapgbbf?hl=en-US",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "dropp://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map